import Swal from 'sweetalert2';

export const swal = {
  success: (message: string, title: string = '¡Éxito!') => {
    return Swal.fire({
      icon: 'success',
      title,
      text: message,
      confirmButtonColor: '#0f4222',
    });
  },

  error: (message: string, title: string = 'Error') => {
    return Swal.fire({
      icon: 'error',
      title,
      text: message,
      confirmButtonColor: '#0f4222',
    });
  },

  warning: (message: string, title: string = 'Advertencia') => {
    return Swal.fire({
      icon: 'warning',
      title,
      text: message,
      confirmButtonColor: '#0f4222',
    });
  },

  info: (message: string, title: string = 'Información') => {
    return Swal.fire({
      icon: 'info',
      title,
      text: message,
      confirmButtonColor: '#0f4222',
    });
  },

  confirm: (message: string, title: string = '¿Estás seguro?') => {
    return Swal.fire({
      icon: 'warning',
      title,
      text: message,
      showCancelButton: true,
      confirmButtonColor: '#0f4222',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
  },
};



